<script setup lang="ts">
  /**
   * Feature list — 03-components/13e-feature-list · OSCloud DS 1.1.166
   *
   * Read-only claims with a check in front of each: what a plan or product includes. Body voice
   * one step under the detail list it usually sits beneath. Not a checklist control — nothing
   * here toggles.
   */
  import BfIconCheck from '@/components/ui/icons/BfIconCheck.vue'

  withDefaults(defineProps<{ items?: string[]; excluded?: string[] }>(), { items: () => [], excluded: () => [] })
</script>

<template>
  <ul class="feature-list">
    <li v-for="item in items" :key="item" class="feature-list__item">
      <BfIconCheck class="feature-list__icon" :size="14" />
      <span>{{ item }}</span>
    </li>
    <li v-for="item in excluded" :key="item" class="feature-list__item feature-list__item--excluded">
      <!-- The minus is card-local, as in the DS: the icon set has no minus glyph. -->
      <svg
        class="feature-list__icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M5 12h14" />
      </svg>
      <span>{{ item }}<span class="sr-only"> - not included</span></span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
  .feature-list {
    display: flex;
    flex-direction: column;
    gap: var(--bf-sp-1);
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .feature-list__item {
    display: flex;
    align-items: flex-start;
    gap: var(--bf-sp-2);
    /* The DS body face, restated: the app's <body> is still the legacy Work Sans. */
    font-family: var(--bf-font-body);
    font-size: var(--bf-fs-xs_5);
    line-height: var(--bf-lh-normal);
    color: var(--bf-fg-1);
  }

  /* Nudged to the first line's x-height so a two-line item keeps its mark at the top. */
  .feature-list__icon {
    flex: 0 0 auto;
    margin-top: 3px;
    color: var(--bf-success);
  }

  /* Muted text and mark: --bf-text-3 (#6b7280) is the DS --text-muted and holds AA on white. */
  .feature-list__item--excluded,
  .feature-list__item--excluded .feature-list__icon {
    color: var(--bf-text-3);
  }
</style>
